import AffectBadge from './AffectBadge';

export default AffectBadge;
